import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import type {GlobalButtonStyleParams} from '../../../utils/useGlobalButtonStyle'
import {colorMetadata, fontMetadata, numberMetadata} from '../../../utils/builderMetadata'

export type ButtonDefaultStylesParams = {
  buttonDefaultFont: StyleParamType.Font
  buttonDefaultColor: StyleParamType.Color
  buttonDefaultFillOpacityColor: StyleParamType.Color
  buttonDefaultBorderOpacityColor: StyleParamType.Color
  buttonDefaultBorderWidth: StyleParamType.Number
  buttonDefaultCornerRadius: StyleParamType.Number
}

export const buttonDefaultStylesParams = createStylesParams<ButtonDefaultStylesParams>({
  buttonDefaultFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  buttonDefaultColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
    metadata: colorMetadata(StyleType.color, 'color-1', 1),
  },
  buttonDefaultFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-8', 1),
  },
  buttonDefaultBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: colorMetadata(StyleType.borderColor, 'color-8', 1),
  },
  buttonDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 0}),
  },
  buttonDefaultCornerRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
})

export type ButtonHoverStylesParams = {
  buttonHoverFillOpacityColor: StyleParamType.Color
  buttonHoverBorderOpacityColor: StyleParamType.Color
  buttonHoverTextColor: StyleParamType.Color
}

export const buttonHoverStylesParams = createStylesParams<ButtonHoverStylesParams>({
  buttonHoverFillOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0.7),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-8', 0.7),
  },
  buttonHoverBorderOpacityColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 0.7),
    metadata: colorMetadata(StyleType.borderColor, 'color-8', 0.7),
  },
  buttonHoverTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
    metadata: colorMetadata(StyleType.color, 'color-1', 1),
  },
})

export const globalButtonStyleParams: GlobalButtonStyleParams = {
  textColor: buttonDefaultStylesParams.buttonDefaultColor,
  fillColor: buttonDefaultStylesParams.buttonDefaultFillOpacityColor,
  borderColor: buttonDefaultStylesParams.buttonDefaultBorderOpacityColor,
  borderWidth: buttonDefaultStylesParams.buttonDefaultBorderWidth,
  hoverTextColor: buttonHoverStylesParams.buttonHoverTextColor,
  hoverFillColor: buttonHoverStylesParams.buttonHoverFillOpacityColor,
  hoverBorderColor: buttonHoverStylesParams.buttonHoverBorderOpacityColor,
}
